import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/clients/new',
  title: 'Cadastrar cliente',
  endpoint: '/app/person',
  breadcrumbs: [],
}
